import React from "react";
import { UserWithBillingPlan } from "../../context/AppContext";
import AppContextProvider from "../../context/AppContextProvider";
import TermsAcceptancePage from "./TermsAcceptancePage";

interface Props {
  user: UserWithBillingPlan | undefined;
  setUser: (user: UserWithBillingPlan) => void;
  children: React.ReactNode;
}

export const requiresTermsAcceptance = (
  user: UserWithBillingPlan | undefined,
): user is UserWithBillingPlan => user?.requires_terms_acceptance === true;

const TermsAcceptanceGate = ({ user, setUser, children }: Props) => {
  // render
  if (!requiresTermsAcceptance(user)) {
    return <>{children}</>;
  }
  return (
    <AppContextProvider user={user} setUser={setUser}>
      <TermsAcceptancePage />
    </AppContextProvider>
  );
};

export default TermsAcceptanceGate;
